import { useQuery } from "@tanstack/react-query";
import { listCheckpoints } from "../../services/lorasApi";
import { loraQueryKeys } from "./queryKeys";

export function useLoraCheckpoints(loraId: string | undefined | null) {
  return useQuery({
    queryKey: loraId
      ? loraQueryKeys.checkpoints(loraId)
      : (["loras", "checkpoints", "_disabled"] as const),
    queryFn: () => listCheckpoints(loraId as string),
    enabled: Boolean(loraId),
  });
}
